import React__default, { forwardRef, useRef, useImperativeHandle, useEffect } from 'react';
import Player from '@vimeo/player';
import { useAnalyticsQueue } from '@invitae/analytics-queue';
import useVideoEvents from '../useVideoEvents.esm.js';
import styles from './Vimeo.module.esm.js';

var NvVimeo = forwardRef(function NvVimeo(videoModel, ref) {
    var autoplay = videoModel.autoplay, muted = videoModel.muted, heading = videoModel.heading, loop = videoModel.loop, vimeoId = videoModel.vimeoId;
    var divRef = useRef(null);
    var playerRef = useRef(null);
    var logEvent = useAnalyticsQueue().logEvent;
    useImperativeHandle(ref, function () { return ({
        get player() {
            return playerRef.current;
        },
        get video() {
            return divRef.current;
        },
    }); }, []);
    var options = {
        // FIXME: change vimeoId contentful type from string to number
        autoplay: autoplay,
        id: vimeoId,
        loop: loop,
        muted: muted,
        responsive: true,
    };
    useEffect(function () {
        logEvent({
            eventName: 'Vimeo video loaded',
            eventProperties: {
                currentPage: window.location.pathname,
                videoName: heading,
            },
        });
        if (!playerRef.current && divRef.current) {
            playerRef.current = new Player(divRef.current, options);
        }
    }, [divRef]);
    useVideoEvents({ options: options, videoModel: videoModel, vimeoPlayer: playerRef });
    useEffect(function () {
        var player = playerRef.current;
        return function () {
            if (player) {
                player.destroy();
                playerRef.current = null;
            }
        };
    }, [playerRef]);
    return React__default.createElement("div", { className: styles['hide-in-percy'], "data-testid": "nv-vimeo", ref: divRef });
});

export { NvVimeo as default };
//# sourceMappingURL=Vimeo.esm.js.map
